import React, { useEffect, useState } from 'react';

import { useRouter } from 'next/router';

const FilterBadge = () => {
  const { query } = useRouter();

  const [filters, setFilters] = useState([]);
  useEffect(() => {
    const firstFourFilters: any = [
      query.governorate &&
        `Ville:&nbsp;<strong> ${decodeURIComponent(
          query.governorate as string
        )}</strong>`,
      ...(query.delegation
        ? decodeURIComponent(query.delegation as string)
            .split(',')
            .map((d) => `Délégation:&nbsp;<strong>${d}</strong>`)
        : []),
      query.q &&
        `Recherche:&nbsp;<strong>${decodeURIComponent(
          query.q as string
        )}</strong>`,
      query.category &&
        `Catégorie:&nbsp;<strong> ${decodeURIComponent(
          query.category as string
        )}</strong>`,
      query.subCategory &&
        `Sous-catégorie:&nbsp;<strong> ${decodeURIComponent(
          query.subCategory as string
        )}</strong>`,
      query.productType &&
        `État de produit:&nbsp;<strong>${decodeURIComponent(
          query.productType as string
        )}</strong>`,
      query.minPrice &&
        `Prix min:&nbsp;<strong>${decodeURIComponent(
          query.minPrice as string
        )}</strong>`,
      query.maxPrice &&
        `Prix max:&nbsp;<strong>${decodeURIComponent(
          query.maxPrice as string
        )}</strong>`,
    ].filter((f) => f);
    const newFilters: any = [];
    Object.entries(query).forEach(([key, value]) => {
      if (
        value &&
        key !== 'governorate' &&
        key !== 'delegation' &&
        key !== 'category' &&
        key !== 'subCategory' &&
        key !== 'productType' &&
        key !== 'q' &&
        key !== 'minPrice' &&
        key !== 'maxPrice' &&
        key !== 'page' &&
        key !== 'after_timestamp'
      ) {
        newFilters.push(
          `${key}:&nbsp;<strong>${decodeURIComponent(value as string)}</strong>`
        );
      }
    });
    setFilters(firstFourFilters.concat(newFilters));
  }, [query]);

  return (
    <div className=" mx-1 ">
      {filters.map((filter) => (
        <>
          <span
            id="badge-dismiss-default"
            className="inline-flex items-center my-1 px-2 py-1 mr-2 text-xs font-medium rounded-md outline outline-1 outline-gray-400 text-gray-800 bg-gray-200/70 "
            dangerouslySetInnerHTML={{ __html: filter }}
          >
            {/* {filter} */}
            {/* <button
              type="button"
              className="inline-flex items-center p-0.5 ml-2 text-sm text-blue-400 bg-transparent rounded-sm  dark:hover:bg-blue-800 dark:hover:text-blue-300"
              data-dismiss-target="#badge-dismiss-default"
              aria-label="Remove"
            >
              <svg
                aria-hidden="true"
                className="w-3.5 h-3.5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <span className="sr-only">Remove badge</span>
            </button> */}
          </span>
        </>
      ))}
    </div>
  );
};

export default FilterBadge;
